import EmployeeCreateComponents from "../components/EmployeeCreate";
import useEmployeeCreate from "../hooks/useEmployeeCreate";

const EmployeeCreate = () => {
  const employeeCreateProps = useEmployeeCreate();
  return <EmployeeCreateComponents {...employeeCreateProps} />
};

export default EmployeeCreate;
